import { Check } from 'lucide-react';
import type { CaseStatus } from '../../shared/case-schema.js';

export interface PublicHistoryEntry {
  id: string;
  at: string;
  action: string;
  toStatus: CaseStatus;
  message: string;
}

export function CaseTimeline({ history }: { history: PublicHistoryEntry[] }) {
  return (
    <ol className="case-timeline" aria-label="Case history">
      {[...history].reverse().map((entry) => (
        <li key={entry.id}>
          <span className="timeline-marker">
            <Check size={14} aria-hidden />
          </span>
          <div>
            <strong>{entry.message}</strong>
            <time dateTime={entry.at}>{formatDate(entry.at)}</time>
          </div>
        </li>
      ))}
    </ol>
  );
}

function formatDate(value: string): string {
  return new Intl.DateTimeFormat('en', {
    dateStyle: 'medium',
    timeStyle: 'short',
  }).format(new Date(value));
}
